(() => {
  const init = () => {
    document.querySelectorAll('[data-open-dialog]').forEach(button => {
      if (button.dataset.mcBound) return;
      button.dataset.mcBound = 'true';
      button.addEventListener('click', () => {
        document.querySelectorAll('.mc-dialog[open]').forEach(dialog => dialog.close());
        document.getElementById(button.dataset.openDialog)?.showModal();
      });
    });
    document.querySelectorAll('.mc-dialog').forEach(dialog => {
      if (dialog.dataset.mcBound) return;
      dialog.dataset.mcBound = 'true';
      dialog.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
    document.querySelectorAll('[data-mc-showcase]').forEach(showcase => {
      if (showcase.dataset.mcBound) return;
      showcase.dataset.mcBound = 'true';
      const track = showcase.querySelector('[data-showcase-track]');
      const slides = [...track.children];
      const count = showcase.querySelector('[data-showcase-count]');
      const pause = showcase.querySelector('[data-showcase-pause]');
      let stopped = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const index = () => Math.round(track.scrollLeft / track.clientWidth);
      const move = next => track.scrollTo({left:((next + slides.length) % slides.length) * track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant':'smooth'});
      const pauseLabel = () => {pause.textContent=stopped?'▶':'Ⅱ';pause.setAttribute('aria-label',stopped?pause.dataset.playLabel:pause.dataset.pauseLabel);};
      showcase.querySelector('[data-showcase-prev]').addEventListener('click',()=>{stopped=true;pauseLabel();move(index()-1);});
      showcase.querySelector('[data-showcase-next]').addEventListener('click',()=>{stopped=true;pauseLabel();move(index()+1);});
      pause.addEventListener('click',()=>{stopped=!stopped;pauseLabel();});
      track.addEventListener('pointerdown',()=>{stopped=true;pauseLabel();});
      track.addEventListener('scroll',()=>{count.textContent=`${index()+1} / ${slides.length}`;},{passive:true});
      setInterval(()=>{if(!stopped&&!document.hidden&&showcase.getBoundingClientRect().bottom>0&&showcase.getBoundingClientRect().top<innerHeight)move(index()+1);},6500);
      pauseLabel();
    });
    document.querySelectorAll('[data-auto-submit]').forEach(input => {
      if (input.dataset.mcBound) return;
      input.dataset.mcBound = 'true';
      input.addEventListener('change', () => input.form.requestSubmit());
    });
    document.querySelectorAll('[data-mc-product]').forEach(product => {
      if (product.dataset.mcBound) return;
      product.dataset.mcBound = 'true';
      const track = product.querySelector('[data-gallery-track]');
      const slides = [...(track?.children || [])];
      const counter = product.querySelector('[data-gallery-counter]');
      const move = index => track?.scrollTo({left: Math.max(0, Math.min(index, slides.length - 1)) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      const index = () => track?.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
      product.querySelector('[data-gallery-prev]')?.addEventListener('click', () => move(index() - 1));
      product.querySelector('[data-gallery-next]')?.addEventListener('click', () => move(index() + 1));
      product.querySelectorAll('[data-gallery-index]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.galleryIndex))));
      track?.addEventListener('scroll', () => {if (counter) counter.textContent = `${index() + 1} / ${slides.length}`;}, {passive:true});
      const variants = JSON.parse(product.querySelector('[data-product-variants]')?.textContent || '[]');
      const labels = JSON.parse(product.querySelector('[data-product-labels]')?.textContent || '{}');
      product.querySelectorAll('[data-option-position]').forEach(input => input.addEventListener('change', () => {
        const selected = [...product.querySelectorAll('[data-option-position]:checked')].sort((a,b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map(option => option.value);
        const variant = variants.find(item => item.options.length === selected.length && item.options.every((value, i) => value === selected[i]));
        const add = product.querySelector('[data-add-button]');
        const id = product.querySelector('[data-variant-id]');
        if (!variant) {add.disabled = true;add.textContent = labels.unavailable;id.disabled = true;return;}
        id.disabled = false;
        id.value = String(variant.id);
        id.dispatchEvent(new Event('change', {bubbles:true}));
        add.disabled = !variant.available;
        add.textContent = variant.available ? labels.add : labels.sold;
        product.querySelector('[data-variant-price]').textContent = variant.price;
        const compare = product.querySelector('[data-variant-compare]');
        compare.hidden = !variant.on_sale;
        compare.textContent = variant.compare;
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
        if (variant.media) {const mediaIndex = slides.findIndex(slide => slide.dataset.mediaId === String(variant.media));if (mediaIndex >= 0) move(mediaIndex);}
        document.dispatchEvent(new CustomEvent('variant:change', {detail:{variant}}));
      }));
    });
    const input = document.querySelector('[data-predictive-input]');
    if (input && !input.dataset.mcBound) {
      input.dataset.mcBound = 'true';
      const results = document.querySelector('[data-predictive-results]');
      let timeout, controller;
      input.addEventListener('input', () => {
        clearTimeout(timeout);
        controller?.abort();
        results.replaceChildren();
        const term = input.value.trim();
        if (term.length < 2) return;
        timeout = setTimeout(async () => {
          controller = new AbortController();
          try {
            const url = new URL(input.form.action.replace(/\/$/, '') + '/suggest');
            url.searchParams.set('q', term);
            url.searchParams.set('section_id', 'mc-predictive-search');
            url.searchParams.set('resources[type]', 'product');
            url.searchParams.set('resources[limit]', '6');
            url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,variants.sku,tag');
            const response = await fetch(url, {signal:controller.signal});
            if (!response.ok) return;
            const html = await response.text();
            if (input.value.trim() !== term) return;
            const documentResult = new DOMParser().parseFromString(html, 'text/html');
            const renderedResults = documentResult.querySelector('[data-mc-predictive-content]');
            results.replaceChildren(...(renderedResults ? [...renderedResults.children] : []));
          } catch (error) {if (error.name !== 'AbortError') results.replaceChildren();}
        }, 220);
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);else init();
  document.addEventListener('shopify:section:load', init);
})();
